import React from 'react';
import ReplayUploadNew from '../upload/ReplayUploadNew';

const HomePage = () => {
    return (
        <div className='bp3-dark home-grid'>
            <div className='home-grid-item'>
                <ReplayUploadNew />
            </div>
        </div>
    )
}

export default HomePage;